"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateName = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var querystring = require("querystring");
var pp_react_1 = require("@paypalcorp/pp-react");
var page = require("page");
var inputs_component_1 = require("../../../components/inputs.component");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var constants_1 = require("../../../constants");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS;
var commonweb_utils_1 = require("commonweb-utils");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var name_1 = require("../../../utils/name");
var beaver_logger_1 = require("../../../utils/logging/beaver-logger");
var constants_2 = require("./constants");
var UpdateName = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateName, _super);
    function UpdateName(props) {
        var _this = _super.call(this, props) || this;
        _this.redirectTo = function (redirectUri) {
            window.location.href = window.location.origin + redirectUri;
        };
        _this.handleFullNameUpdateResp = function (data) {
            var _a = _this.props.name, comingFromANW = _a.comingFromANW, stepUpPassed = _a.stepUpPassed;
            if (_this.riskLevel.includes("LOW") || (comingFromANW && stepUpPassed)) {
                triggerOperationResult_1.triggerOperationResult("update user's name", "Coming From ANW", comingFromANW);
                var settingsUri = "/myaccount/settings/?success=name_update_success";
                _this.redirectTo(settingsUri);
            }
        };
        _this.updateFullName = function () {
            return ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.NAME.UPDATE, _this.formData, { component: { name: VIEWS.UPDATE_NAME } });
        };
        _this.handleLowRisk = function () {
            return _this.updateFullName();
        };
        _this.handleMediumRisk = function (data) {
            var params = {
                stepupContext: data.auth_context_id,
                returnUri: "/myaccount/profile/flow/name/edit",
                flowId: "8ball",
                flowContext: "namechange",
            };
            var authFlowUri = "/authflow/entry?" + querystring.stringify(params);
            if (window && window.sessionStorage) {
                window.sessionStorage.setItem("name", JSON.stringify(_this.formData));
            }
            _this.redirectTo(authFlowUri);
        };
        _this.handleHighRisk = function (data) {
            page(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.NAME.CHANGE_REASON);
        };
        _this.handleRiskLevelResp = function (_a) {
            var data = _a.data;
            _this.riskLevel = (commonweb_utils_1.objectUtils.safeGet(data, "riskLevel") || "").toUpperCase();
            triggerOperationResult_1.triggerOperationResult("get risk level", "SUCCESS", _this.riskLevel);
            if (_this.riskLevel.includes("HIGH")) {
                _this.handleHighRisk(data);
            }
            else if (_this.riskLevel.includes("MEDIUM")) {
                _this.handleMediumRisk(data);
            }
            else if (_this.riskLevel.includes("LOW")) {
                return _this.handleLowRisk();
            }
        };
        _this.getRiskLevel = function () {
            var body = {
                newName: _this.formData,
                oldName: _this.props.name,
            };
            triggerOperationResult_1.triggerOperationResult("calling risk api", "SUCCESS", "/api/name/getRiskLevel");
            return ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.NAME.CHECK_NAME_CHANGE_RISK_LEVEL, body);
        };
        _this.submitHandler = function (event) {
            if (event) {
                event.preventDefault();
            }
            var updatedForm = tslib_1.__assign({}, _this.state.pageInputs);
            var inputs = updatedForm[_this.state.pageName];
            var firstName = commonweb_utils_1.objectUtils.safeGet(_this.state, "pageInputs.newNameForm.form.firstNameInput.value") || "";
            var lastName = commonweb_utils_1.objectUtils.safeGet(_this.state, "pageInputs.newNameForm.form.lastNameInput.value") || "";
            if (_this.props.name.firstName === firstName &&
                lastName === _this.props.name.lastName) {
                inputs.formMessage = _this.props.content.name.error.sameName;
                _this.setState({
                    pageInputs: updatedForm,
                    showSpinner: false,
                });
                return;
            }
            if (!inputs.formIsValid || !firstName) {
                inputs.formMessage = _this.props.content.name.edit.nameError;
                _this.setState({
                    pageInputs: updatedForm,
                    showSpinner: false,
                });
                return;
            }
            var form = inputs.form;
            for (var formElementIdentifier in form) {
                _this.formData[formElementIdentifier] =
                    form[formElementIdentifier].value;
            }
            _this.setState({
                showSpinner: true,
            });
            _this.getRiskLevel()
                .then(_this.handleRiskLevelResp)
                .then(_this.handleFullNameUpdateResp)
                .catch(function (error) {
                var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "error.statusCode") || 500;
                beaver_logger_1.default().info(constants_2.NAME.RISK_LEVEL, {
                    errorCode: errorStatusCode,
                    message: error && error.message,
                });
                if (errorStatusCode >= 400 && errorStatusCode < 500) {
                    inputs.formMessage = _this.props.content.name.edit.nameError;
                    _this.setState({
                        pageInputs: updatedForm,
                        showSpinner: false,
                    });
                }
                else {
                    inputs.formMessage = _this.props.content.common.genericServerError;
                    _this.setState({
                        pageInputs: updatedForm,
                        showSpinner: false,
                    });
                }
                triggerOperationResult_1.triggerOperationResult("error while updating name", "FAILURE", error);
                return;
            });
        };
        _this.getFormTemplate = function () {
            var formElementsArray = [];
            var nameContent = _this.props.content.name;
            var inputs = _this.state.pageInputs[_this.state.pageName];
            // tslint:disable-next-line:forin no-for-in
            for (var key in inputs.form) {
                formElementsArray.push({
                    elementName: key,
                    elementProperties: inputs.form[key],
                });
            }
            return (React.createElement("form", { className: "newNameChange-new_name_form", onSubmit: function (event) { return _this.submitHandler(event); } },
                inputs.formMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert newNameChange-error_class" }, inputs.formMessage)) : null,
                React.createElement(pp_react_1.Text, { size: "xl3", className: "newNameChange-new_name_header" }, nameContent.newNameHomeScreen.header),
                React.createElement(pp_react_1.Text, { size: "sm", className: "newNameChange-name_subheader" }, nameContent.newNameHomeScreen.subheader),
                formElementsArray.map(function (formElement) { return (React.createElement(inputs_component_1.default, { key: formElement.elementName, id: formElement.elementName, name: formElement.elementName, elementType: formElement.elementProperties.elementType, elementConfig: formElement.elementProperties.elementConfig, value: formElement.elementProperties.value, isInvalid: !formElement.elementProperties.isValid, shouldValidate: formElement.elementProperties.validation, isTouched: formElement.elementProperties.isTouched, changed: function (event) {
                        return name_1.inputChangedHandler(event, formElement.elementName, _this.state, _this.setState.bind(_this));
                    }, helperText: formElement.elementProperties.helperText || null, className: "newNameChange-name_textinput" })); }),
                React.createElement(pp_react_1.Button, { className: "newNameChange-name_submit_button", name: "nameUpdateSubmit", disabled: _this.state.showSpinner, type: "submit" }, _this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (_this.props.content.common.continue))));
        };
        _this.state = {
            showSpinner: false,
            riskLevel: null,
            userCiped: false,
            pageName: "newNameForm",
            formIsValid: true,
            errorMessage: "",
            pageInputs: {
                newNameForm: {
                    form: {
                        firstNameInput: {
                            elementType: "input",
                            elementConfig: {
                                type: "text",
                                label: commonweb_utils_1.objectUtils.safeGet(props, "content.name.firstName.label") || "",
                                suggestionText: commonweb_utils_1.objectUtils.safeGet(props, "content.name.name.error") || "",
                            },
                            value: commonweb_utils_1.objectUtils.safeGet(props, "name.firstName") || "",
                            validation: {
                                required: true,
                            },
                            isValid: false,
                            isTouched: false,
                            helperText: commonweb_utils_1.objectUtils.safeGet(props, "content.name.newNameHomeScreen.firstName.helperText") || null,
                        },
                        lastNameInput: {
                            elementType: "input",
                            elementConfig: {
                                type: "text",
                                label: commonweb_utils_1.objectUtils.safeGet(props, "content.name.lastName.label") || "",
                                suggestionText: commonweb_utils_1.objectUtils.safeGet(props, "content.name.name.error") || "",
                            },
                            value: commonweb_utils_1.objectUtils.safeGet(props, "name.lastName") || "",
                            validation: {
                                required: true,
                            },
                            isValid: false,
                            isTouched: false,
                            helperText: commonweb_utils_1.objectUtils.safeGet(props, "content.name.newNameHomeScreen.lastName.helperText") || null,
                        },
                    },
                    formIsValid: false,
                    formMessage: "",
                },
            },
        };
        _this.riskLevel = "";
        _this.formData = {};
        return _this;
    }
    UpdateName.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        var riskLevel = nextProps.name.userActionRiskLevel;
        var userCiped = nextProps.name.userCiped;
        this.setState({
            riskLevel: riskLevel,
            userCiped: userCiped,
        });
        if (userCiped || !nextProps.name.stepUpPassed) {
            page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.NAME.CHANGE_REASON);
        }
        userCiped
            ? triggerOperationResult_1.triggerOperationResult("get cip status", "SUCCESS", "ciped")
            : triggerOperationResult_1.triggerOperationResult("get cip status", "SUCCESS", "non ciped");
    };
    UpdateName.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props.name, comingFromANW = _a.comingFromANW, stepUpPassed = _a.stepUpPassed;
        var storedNameValues = "";
        if (window && window.sessionStorage) {
            storedNameValues = window.sessionStorage.getItem("name");
        }
        if (comingFromANW && stepUpPassed && storedNameValues) {
            storedNameValues = storedNameValues
                ? JSON.parse(storedNameValues)
                : {};
            var updatedForm_1 = tslib_1.__assign({}, this.state.pageInputs);
            var inputs_1 = updatedForm_1[this.state.pageName].form;
            inputs_1.firstNameInput.value = storedNameValues["firstNameInput"];
            inputs_1.lastNameInput.value = storedNameValues["lastNameInput"];
            this.setState({
                showSpinner: true,
                pageInputs: updatedForm_1,
            });
            this.formData = storedNameValues;
            this.updateFullName()
                .then(this.handleFullNameUpdateResp)
                .catch(function (error) {
                var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "error.statusCode") || 500;
                beaver_logger_1.default().info(constants_2.NAME.UPDATE_NAME, {
                    errorCode: errorStatusCode,
                    message: error && error.message,
                });
                if (errorStatusCode >= 400 && errorStatusCode < 500) {
                    inputs_1.formMessage = _this.props.content.name.edit.nameError;
                    _this.setState({
                        pageInputs: updatedForm_1,
                        showSpinner: false,
                    });
                }
                else {
                    inputs_1.formMessage = _this.props.content.common.genericServerError;
                    _this.setState({
                        pageInputs: updatedForm_1,
                        showSpinner: false,
                    });
                }
                triggerOperationResult_1.triggerOperationResult("error while updating name", "FAILURE", error);
                return;
            });
        }
    };
    UpdateName.prototype.render = function () {
        return (React.createElement("div", { className: "generic-container" }, this.getFormTemplate()));
    };
    return UpdateName;
}(React.Component));
exports.UpdateName = UpdateName;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti;
    var name = commonweb_utils_1.objectUtils.safeGet(account, "name") || {};
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        name: name,
        links: links,
        fpti: fpti,
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        dispatch: dispatch,
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UpdateName);
